import React from 'react';
import { useSelector } from 'react-redux';
import { navigate } from '@reach/router';
import './Unauthorized403.scss';
import { Paths } from '@/pages/routers';
import { RootState } from '@/redux/reducers';
import IconShield from '@/assets/icons/shield.svg';

const Unauthorized403 = () => {
  const error: any = useSelector((state: RootState) => state.errors.FETCH_ENTITY_DASHBOARD);

  const goToLogin = () => {
    navigate(`${Paths.Auth}${Paths.Login}`);
  };

  return (
    <div className="Unauthorized403">
      <div className="Unauthorized403-image">
        <img src={IconShield} alt="Open Banking" />
      </div>
      <h1 className="Unauthorized403-title">We Are Sorry</h1>
      <p className="Unauthorized403-description">
        {error?.message || (
          <>
            It seems like you do not have permission to access this site
            <br />
            Please contact support
          </>
        )}
      </p>
      <div className="Unauthorized403-login">
        If you are a member, <span onClick={goToLogin}>click here to login</span>
      </div>
    </div>
  );
};

export default Unauthorized403;
